import { render } from "./ReportsHome.vue?vue&type=template&id=b65b7ed8"
import script from "./ReportsHome.vue?vue&type=script&lang=js"
export * from "./ReportsHome.vue?vue&type=script&lang=js"

import "./ReportsHome.vue?vue&type=style&index=0&id=b65b7ed8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__